$ = require 'jquery'
Singleton = require '../../pattern/singleton'
Elements = require './elements'
Data = require '../data'
{ forEach } = require 'lodash'
{ toAngle, getHeight } = require '../../components/math'
{ displayMoment } = require '../../components/element-operation'

module.exports =
class SetPosition extends Singleton

  selector            : '.section'
  contentsWrapSelector: '.contents-wrap'
  headingSelector     : '.heading-container'
  contentsSelector    : '.contents-container'
  contentsInrSelector : '.inner'

  constructor: ->
    super

    @$window = Elements.$window
      .one
        'pagesLoaded' : @onPagesLoaded
        'imagesLoaded': @reset
    @$wrap = Elements.$wrap

    @headingMovePoints = []

  onPagesLoaded: =>
    @$window.on 'resize', @reset

    @$section      = $ @selector
    @$contentsWrap = @$section.find @contentsWrapSelector
    @$heading      = @$section.find @headingSelector
    @$contents     = @$section.find @contentsSelector
    @$contentsInr  = @$contents.find @contentsInrSelector

  reset: =>
    @winH = @$window.height()
    displayMoment @$section.not(":eq(#{Data.location})"), @setSectionInfo
    @setHeadingPos()

  setSectionInfo: =>
    forEach @$contents, (el, i) =>
      $el       = $ el
      h         = @$contentsInr.eq(i).outerHeight()
      contentsW = $el.width()
      overH = getHeight contentsW, toAngle(10)
      if i
        $el.css 'margin-top', -(h / 2)
      @headingMovePoints[i] = h + overH + @$heading.eq(i).height()

  setHeadingPos: ->
    forEach @$heading, (el, i) =>
      shift = @winH - @headingMovePoints[i]
      shift = 0 if 0 < shift
      if i
        $(el).css 'top', "#{shift / 2}px"
      else
        @$contentsWrap.eq i
          .css 'top', "#{shift / 2}px"



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/set-position.coffee